var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 75,
    viewBox: "0 0 100 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_106_676",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 75
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 75,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_106_676)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H100V75H0V0Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 45.8333V52.0833H100V45.8333H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 57.2917V63.5417H100V57.2917H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 22.9167V29.1667H100V22.9167H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 68.75V75H100V68.75H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 34.375V40.625H100V34.375H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V6.25H100V0H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.4583V17.7083H100V11.4583H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 62.5,
    height: 40.625,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41296 31.1499H8.65613L6.89343 32.9438L7.57605 35.7739L5.38171 34.1831L3.11316 35.7739L3.87878 32.9438L1.86414 31.1499H4.49597L5.37781 28.8403L6.41296 31.1499ZM18.913 31.1499H21.1561L19.3934 32.9438L20.076 35.7739L17.8817 34.1831L15.6132 35.7739L16.3788 32.9438L14.3641 31.1499H16.996L17.8778 28.8403L18.913 31.1499ZM31.413 31.1499H33.6561L31.8934 32.9438L32.576 35.7739L30.3817 34.1831L28.1132 35.7739L28.8788 32.9438L26.8641 31.1499H29.496L30.3778 28.8403L31.413 31.1499ZM43.913 31.1499H46.1561L44.3934 32.9438L45.076 35.7739L42.8817 34.1831L40.6132 35.7739L41.3788 32.9438L39.3641 31.1499H41.996L42.8778 28.8403L43.913 31.1499ZM56.413 31.1499H58.6561L56.8934 32.9438L57.576 35.7739L55.3817 34.1831L53.1132 35.7739L53.8788 32.9438L51.8641 31.1499H54.496L55.3778 28.8403L56.413 31.1499ZM12.663 24.8999H14.9061L13.1434 26.6938L13.826 29.5239L11.6317 27.9331L9.36316 29.5239L10.1288 26.6938L8.11414 24.8999H10.746L11.6278 22.5903L12.663 24.8999ZM25.163 24.8999H27.4061L25.6434 26.6938L26.326 29.5239L24.1317 27.9331L21.8632 29.5239L22.6288 26.6938L20.6141 24.8999H23.246L24.1278 22.5903L25.163 24.8999ZM37.663 24.8999H39.9061L38.1434 26.6938L38.826 29.5239L36.6317 27.9331L34.3632 29.5239L35.1288 26.6938L33.1141 24.8999H35.746L36.6278 22.5903L37.663 24.8999ZM50.163 24.8999H52.4061L50.6434 26.6938L51.326 29.5239L49.1317 27.9331L46.8632 29.5239L47.6288 26.6938L45.6141 24.8999H48.246L49.1278 22.5903L50.163 24.8999ZM6.41296 18.6499H8.65613L6.89343 20.4438L7.57605 23.2739L5.38171 21.6831L3.11316 23.2739L3.87878 20.4438L1.86414 18.6499H4.49597L5.37781 16.3403L6.41296 18.6499ZM18.913 18.6499H21.1561L19.3934 20.4438L20.076 23.2739L17.8817 21.6831L15.6132 23.2739L16.3788 20.4438L14.3641 18.6499H16.996L17.8778 16.3403L18.913 18.6499ZM31.413 18.6499H33.6561L31.8934 20.4438L32.576 23.2739L30.3817 21.6831L28.1132 23.2739L28.8788 20.4438L26.8641 18.6499H29.496L30.3778 16.3403L31.413 18.6499ZM43.913 18.6499H46.1561L44.3934 20.4438L45.076 23.2739L42.8817 21.6831L40.6132 23.2739L41.3788 20.4438L39.3641 18.6499H41.996L42.8778 16.3403L43.913 18.6499ZM56.413 18.6499H58.6561L56.8934 20.4438L57.576 23.2739L55.3817 21.6831L53.1132 23.2739L53.8788 20.4438L51.8641 18.6499H54.496L55.3778 16.3403L56.413 18.6499ZM12.663 12.3999H14.9061L13.1434 14.1938L13.826 17.0239L11.6317 15.4331L9.36316 17.0239L10.1288 14.1938L8.11414 12.3999H10.746L11.6278 10.0903L12.663 12.3999ZM25.163 12.3999H27.4061L25.6434 14.1938L26.326 17.0239L24.1317 15.4331L21.8632 17.0239L22.6288 14.1938L20.6141 12.3999H23.246L24.1278 10.0903L25.163 12.3999ZM37.663 12.3999H39.9061L38.1434 14.1938L38.826 17.0239L36.6317 15.4331L34.3632 17.0239L35.1288 14.1938L33.1141 12.3999H35.746L36.6278 10.0903L37.663 12.3999ZM50.163 12.3999H52.4061L50.6434 14.1938L51.326 17.0239L49.1317 15.4331L46.8632 17.0239L47.6288 14.1938L45.6141 12.3999H48.246L49.1278 10.0903L50.163 12.3999ZM6.41296 6.1499H8.65613L6.89343 7.94385L7.57605 10.7739L5.38171 9.18311L3.11316 10.7739L3.87878 7.94385L1.86414 6.1499H4.49597L5.37781 3.84033L6.41296 6.1499ZM18.913 6.1499H21.1561L19.3934 7.94385L20.076 10.7739L17.8817 9.18311L15.6132 10.7739L16.3788 7.94385L14.3641 6.1499H16.996L17.8778 3.84033L18.913 6.1499ZM31.413 6.1499H33.6561L31.8934 7.94385L32.576 10.7739L30.3817 9.18311L28.1132 10.7739L28.8788 7.94385L26.8641 6.1499H29.496L30.3778 3.84033L31.413 6.1499ZM43.913 6.1499H46.1561L44.3934 7.94385L45.076 10.7739L42.8817 9.18311L40.6132 10.7739L41.3788 7.94385L39.3641 6.1499H41.996L42.8778 3.84033L43.913 6.1499ZM56.413 6.1499H58.6561L56.8934 7.94385L57.576 10.7739L55.3817 9.18311L53.1132 10.7739L53.8788 7.94385L51.8641 6.1499H54.496L55.3778 3.84033L56.413 6.1499Z",
    fill: "#F7FCFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsFlag);
export default __webpack_public_path__ + "static/media/US-flag.b1decc021858de00da7d0a7dc4e0e448.svg";
export { ForwardRef as ReactComponent };